<template>
  <div class="activity-list-area" :class="{'new-distance':!isInNative}">
    <div class="shop-header">
      <EntitySecond :itemData="storeInfo"/>
      <Nav :navData="menuInfo || []"/>
    </div>
    <!-- <Nav :navData="menuInfo" /> -->
    <template v-if="activityList.length > 0">
      <div class="activitys">
        <div class="activity-card" v-for="(activityData,index) in activityList" :key="index">
          <div class="title" v-if="activityData.data && activityData.data.length>0">
            {{activityTypeToName[activityData.activityType]}}
          </div>
          <component
            :is="TimeLimitDiscountItem"
            :itemData="itemData"
            :currentTime="currentTime"
            v-for="(itemData,index) in activityData.data.slice(0,4)"
            :storeInfo="storeInfo"
            :key="index"
            @remove="onRemoveOne"
            :sortIndex="index+1"
          />
          <div class="g-content g-card-btn" @click="goDiscountList" v-if="activityData.data.length>4">查看全部</div>
        </div>
      </div>
    </template>

    <zs-infinite ref="infinite" @infinite="onLoadData" :isAutoLoad="true" noResultText="" no-more-text="没有更多内容了">
      <placeholder
        slot="no-results"
        icon="play"
        title="店铺还没有活动哦"
      />
    </zs-infinite>
  </div>
</template>
<script>
  //components, data, asyncData, computed, watch, created, mounted , destroy, methods
  import Nav from '../../components/cards/Nav'
  import EntitySecond from '../../components/items/Entity2'
  import Api from "../../service/api"
  import CourseItem01 from '../../components/items/course-item-01'
  import Placeholder from '@/components/placeholder.vue'
  import store from "../../store"
  import {mapGetters} from 'vuex'
  import priceTimelimit from '@/utils/price-cal'
  import dateformat from '@/utils/date-format'
  import TimeLimitDiscountItem from '@/components/items/TimeLimitDiscountItem'
  import pv from '@/service/pingback/pv'

  let timer
  export default {
    components: {
      Nav,
      EntitySecond,
      CourseItem01,
      TimeLimitDiscountItem,
      Placeholder
    },
    props: {},
    data() {
      return {
        pageIndex: 1,
        pageSize: 10,
        pageTotal: 0,
        dataTotal: 0,
        banner: null,
        itemsData: [],
        shopData: {},
        activityList: [],
        activityTypeToName: {
          1: '限时优惠',
          2: 'VIP折扣',
          3: '拼团优惠'
        },
        intervalTime: {},
        TimeLimitDiscountItem: "TimeLimitDiscountItem",
        currentTime: Date.now(),
        isInNative: false
      }
    },
    computed: {
      ...mapGetters('category', {
        storeInfo: 'getStoreInfo',
        menuInfo: 'getMenuInfo'
      }),
    },
    created() {
      // if (timer) {
      //     clearInterval(timer)
      // } else {
      timer = setInterval(() => {
        this.currentTime = Date.now()
      }, 1000)
      // }
      if (this.storeInfo.key) {
        pv.send({
          rpage: `knowledge_h5_shop_${this.storeInfo.key}_活动页`,
          v: 1
        })
      }
      if (window.browser.iqiyi || window.browser.knowledge) {
        this.isInNative = true
      }
    },
    mounted() {
    },
    destroy() {
      if (timer) {
        clearInterval(timer)
      }
    },
    methods: {
      calIntervalTime(data) {
        const now = Date.now()
        const endDate = new Date(data.deadline.replace(/-/g, '/'))
        if (endDate) {
          const end = endDate.getTime()
          if (end > now) {
            return this.formatInterval(end - now)
          }
        }
      },

      formatInterval(interval) {
        interval = interval / 1000
        const d = parseInt(interval / (24 * 60 * 60))
        const h = parseInt(interval / (60 * 60) % 24)
        const m = parseInt(interval / 60 % 60)
        const s = parseInt(interval % 60)

        if (d >= 1) {
          this.intervalTime = {d: dateformat(d), h: dateformat(h), m: dateformat(m), s: ''}
        } else {
          this.intervalTime = {d: '', h: dateformat(h), m: dateformat(m), s: dateformat(s)}
        }
        return this.intervalTime
      },
      /**
       * 获取活动数据
       */
      async getActivityList(params) {
        const data = await Api.getActivityList(params)
        this.activityList = data || []
      },

      handleData(data) {
        return {
          "contentName": data.contentName,
          "contentPic": "http://pic7.iqiyipic.com/image/20190731/3e/f7/a_100159346_m_601_m8.jpg",
          "promptDescription": data.promptDescription,
          "lecturer": data.lecturer
        }
      },

      async getShopData() {
        let param = this.$route.params.pageId;
        let arr = []
        if (param) {
          arr = param.split('.html');
        }
        let data = await Api.read(arr[0], '', false)
        this.navData = data.tabs || []
        pv.send({
          rpage: `knowledge_h5_shop_${data.storeInfo.key}_活动页`,
        })
        //存储店铺和菜单信息
        store.dispatch('category/storeInfo', {
          storeInfo: data.storeInfo || {}
        })
        store.dispatch('category/menuInfo', {
          menuInfo: this.navData
        })
        return data
      },

      /**
       * 触底回调函数
       */
      async onLoadData() {
        try {
          const $infinite = this.$refs.infinite
          let id
          if (!this.storeInfo.iqiyiId) {
            let data = await this.getShopData()
            id = String(data.storeInfo.iqiyiId)
          } else {
            id = String(this.storeInfo.iqiyiId)
          }
          let length = id.length
          await this.getActivityList({
            qiyihaoId: Number(id.slice(0, length - 2))
          })

          let items = []
          if (this.activityList.length > 0) {
            items = this.activityList[0].data || []
          }
          if (items.length === 0) {
            $infinite.none()
            return
          }

          $infinite.complete()
        } catch (err) {
          throw err
        }
      },
      calPrice(data) {
        return priceTimelimit(data.originPrice, data.discountPrice)
      },
      onRemoveOne(item) {
        let index = -1;
        let activityData = this.activityList && this.activityList[0].data
        for (let i = 0; i < activityData.length; i++) {
          const d = activityData[i]
          if (d.contentId === item.contentId) {
            index = i;
            break;
          }
        }
        if (index !== -1) {
          this.activityList[0].data.splice(index, 1);
        }

        if (this.activityList[0].data.length === 0) {
          this.$refs.infinite.none()
        }
      },

      goDiscountList() {
        pv.click({
          rpage: `knowledge_h5_shop_${this.storeInfo.key}_活动页`,
          block: 'discount',
          rseat: 'more'
        })
        this.$router.push({
          name: 'discount-list',
        })
      }
    }
  }
</script>
<style lang="less">
  .activity-list-area {
    &.view {
      margin-top: 0px;
    }

    &.new-distance {
      margin-top: -14px !important;
    }

    .zs-infinite-loading-container {
      background-color: #fff;
    }

    .no-show {
      display: none;
    }

    .no-data {
      .no-data-tips {
        color: #999;
        font-size: 14px;
      }

      .no-data-instruct {
        font-size: 12px;
        color: #b5b5b5;
        margin-top: 16px;
      }

      img {
        width: 90px;
        height: 90px;
      }

      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      color: #666;
      margin-top: 30%;
    }

    .activitys {
      background-color: #fff;
      padding-top: 25px;
      min-height: 30px;

      .title {
        color: #1f1f1f;
        font-size: 17px;
        margin-left: 15px;
        margin-bottom: 11px;
        font-weight: bold;
      }
    }
  }
</style>
